import { SxProps } from '@mui/material';
import { Control, FieldError, FieldValues } from 'react-hook-form';

import { Size } from 'theme/enums';

import CheckboxInputView from './CheckboxInputView';
import CheckboxInputWithControllerView from './CheckboxInputWithControllerView';

export interface IProps {
  control?: Control<FieldValues, object>;
  error?: FieldError;
  name?: string;
  defaultValue?: boolean;
  disabled?: boolean;
  label?: string | string[] | JSX.Element;
  size?: Size;
  onKeyDown?: (event) => void;
  onChange?: (event) => void;
  value?: boolean;
  sx?: SxProps;
  endDecorator?: JSX.Element;
  disabledTooltip?: string;
}

const CheckboxInput = (props: IProps) => {
  const { control, value } = props;

  if (control) {
    return <CheckboxInputWithControllerView {...props} />;
  }

  return <CheckboxInputView value={value} {...props} />;
};

export default CheckboxInput;
